const getAPIURL = () => {
   // const isServer = typeof window === 'undefined';
   // const baseURL = isServer ? 'http://localhost:3000' : window.location.origin;
   const apiURL = process.env.PUBLIC_API_URL || window.location.origin;
   return apiURL;
};

const apiURL = getAPIURL();
const Config = {
   API_BASE_URL: apiURL,
   API_URL: `${apiURL}/api`,
};

export default Config;
